import { Box, TextField, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import TypingIntro from './TypingIntro';
import CodeConsole from './CodeConsole';

function DataQualityAgentLog({ data }) {
  const scrollRef = useRef(null);

  const [displayedText, setDisplayedText] = useState(['', '']);
  const [lineIndex, setLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [data]);

  const lines = [
    '🖐️ Hello! I’m the Data Quality Agent.',
    '📃 I specialize in profiling data, generating quality rules, and applying them to improve your dataset.',
  ];

  useEffect(() => {
    if (lineIndex < lines.length) {
      if (charIndex < lines[lineIndex].length) {
        const timeout = setTimeout(() => {
          setDisplayedText((prev) => {
            const updated = [...prev];
            updated[lineIndex] += lines[lineIndex][charIndex];
            return updated;
          });
          setCharIndex((prev) => prev + 1);
        }, 40);
        return () => clearTimeout(timeout);
      }
    }
  }, [charIndex, lineIndex, lines]);

  const getColor = (type) => {
    switch (type) {
      case 'message':
        return '#16a34a';
      case 'rule':
        return '#0284c7';
      case 'finish':
        return '#d97706';
      default:
        return '#000';
    }
  };

  return (
    <Box>
      {/* 🔹 Heading box outside the log container */}
      <TypingIntro />
      <Box sx={{ fontWeight: 'bold', mb: 1 }}>🧠 Logs Viewer</Box>
      {/* 🔸 Main log container */}
      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          // backgroundColor: '#1c2833',
          // color: '#2ecc71',
          padding: 2,
          borderRadius: 2,
          fontFamily: 'monospace',
          border: '1px solid #ccc',
          height: '60vh',
          overflowY: 'auto',
        }}
      >
        {data?.map((log, idx) => (
          <React.Fragment key={idx}>
            {log.type === 'rule' ? (
              <Box display="flex" alignItems="center" sx={{ my: 2 }}>
                {/* <FormControl style={{ width: '25%' }} size="small">
                  <InputLabel>Metric</InputLabel>
                  <Select
                    id={`metric-${idx}`}
                    name="metric"
                    size="small"
                    label="Metric"
                    value={log.metric}
                    disabled
                    sx={{ background: '#ffffff' }}
                  >
                    <MenuItem value={log.metric}>{log.metric}</MenuItem>
                  </Select>
                </FormControl> */}

                <TextField
                  variant="outlined"
                  size="small"
                  label="Rule"
                  fullWidth
                  value={log.message}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: 'black',
                      },
                      '&:hover fieldset': {
                        borderColor: 'black',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: 'black',
                      },
                    },
                    '& .MuiInputBase-input.Mui-disabled': {
                      WebkitTextFillColor: 'black', // Ensures text is black even when disabled
                    },
                    '& .MuiInputLabel-root.Mui-disabled': {
                      color: 'black', // Label color when disabled
                    },
                  }}
                  disabled
                />
              </Box>
            ) : log.type === 'code' ? (
              <CodeConsole language="python" code={log.message} />
            ) : (
              <Typography>{log.message}</Typography>
            )}
          </React.Fragment>
        ))}
        <div ref={scrollRef} />
      </Box>
    </Box>
  );
}

export default DataQualityAgentLog;
